<template>
  <div class="bet-detail-page">
    <div class="nav">
      <span>彩种</span>
      <DropDownMenu :dropList="gameList" v-model="choiceOption" />
      <span>日期</span>
      <DropDownMenu :dropList="beforDateList" v-model="beforDate" />
      <span>期数</span>
      <DropDownMenu :dropList="issueList" v-model="issue" />
      <span>状态</span>
      <DropDownMenu :dropList="statusList" v-model="status" />
      <span>订单号</span>
      <input class="search-order input" type="text" v-model="orderId" />
      <input
        class="search btn primary"
        type="button"
        @click="search()"
        value="查询"
      />
      <input
        class="recharge btn plain"
        type="button"
        @click="batchCharge()"
        value="批量退码"
      />
    </div>
    <table class="detail-table" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th>注单编号</th>
          <th>期号</th>
          <th>下单时间</th>
          <th>号码</th>
          <th>赔率</th>
          <th>金额</th>
          <th>中奖</th>
          <th>回水</th>
          <th>盈亏</th>
          <th style="white-space: nowrap">状态</th>
          <th style="display: flex; align-items: center">
            <el-checkbox
              class="checkbox dark"
              v-model="checkAll"
              label="全选"
            />
            <input
              style="
                margin-left: 50px;
                padding: 0px 8px;
                height: unset;
                line-height: 23px;
                font-size: 12px;
              "
              class="btn primary"
              type="button"
              @click="recharge()"
              value="退码"
            />
          </th>
        </tr>
      </thead>
      <tbody id="betList" v-if="betList.length == 0">
        <tr>
          <td colspan="11" style="background: transparent; height: 300px">
            <div class="noData"></div>
          </td>
        </tr>
      </tbody>
      <tbody id="betList" v-else>
        <tr
          v-for="(item, index) in betList"
          :key="index"
          :class="{ charge: item.orderStatus == 2 }"
        >
          <td>{{ item.orderId }}</td>
          <td>{{ item.issue }}</td>
          <td>
            <div style="line-height: 20px; white-space: nowrap">
              {{ item.betTime | timeFormate }}
            </div>
            <div style="line-height: 20px">
              {{ item.chargebackTime != 0 ? "退" : "" }}
              {{
                item.chargebackTime != 0
                  ? item.chargebackTime
                  : "" | timeFormate
              }}
            </div>
          </td>
          <td>{{ item.betNumber }}</td>
          <td class="active-text bold">
            {{
              item.betNumber.match(/[0-9]/gi).length == 1
                ? (item.peilv * 1).toFixed(2)
                : (item.peilv * 1).toFixed(2)
            }}
          </td>
          <td>{{ (item.money * 1).toFixed(2) }}</td>
          <td :style="item.peie * 1 > 0 ? 'color : red' : ''">
            {{ item.orderStatus == 1 ? (item.peie * 1).toFixed(2) : "-" }}
          </td>
          <td>{{ (item.back * 1).toFixed(2) }}</td>
          <td>
            {{
              isNaN(
                (
                  parseFloat(item.peie) +
                  parseFloat(item.back) -
                  parseFloat(item.money)
                ).toFixed(2)
              )
                ? "--"
                : (
                    parseFloat(item.peie) +
                    parseFloat(item.back) -
                    parseFloat(item.money)
                  ).toFixed(2)
            }}
          </td>
          <td style="white-space: nowrap">
            {{
              item.peie * 1 == 0 && item.orderStatus == 1
                ? "未中 "
                : item.peie * 1 != 0 && item.orderStatus == 1
                ? "中奖"
                : item.orderStatus == 0
                ? "成功"
                : item.orderStatus == 2
                ? "退码"
                : item.orderStatus == 4
                ? "撤回"
                : "-"
            }}
          </td>
          <td>
            <span
              v-if="
                item.orderStatus == 2 ||
                item.issue != nowIssue ||
                (item.issue == nowIssue && isClose == 1)
              "
              >--</span
            >
            <input
              v-else
              v-model="item.checked"
              class="checkbox"
              type="checkbox"
            />
          </td>
        </tr>
        <tr class="bold summary">
          <td colspan="5" style="text-align: center">合计</td>
          <td
            style="
              border-left: 1px solid var(--new-border);
              border-right: 1px solid var(--new-border);
            "
          >
            {{
              (
                sum(
                  betList.filter((item) => item.orderStatus != 2),
                  "money"
                ) * 1
              ).toFixed(2)
            }}
          </td>
          <td style="border-right: 1px solid var(--new-border)">
            {{
              (
                sum(
                  betList.filter((item) => item.orderStatus != 2),
                  "peie"
                ) * 1
              ).toFixed(2)
            }}
          </td>
          <td style="border-right: 1px solid var(--new-border)">
            {{
              (
                sum(
                  betList.filter((item) => item.orderStatus != 2),
                  "back"
                ) * 1
              ).toFixed(2)
            }}
          </td>
          <td style="border-right: 1px solid var(--new-border)">
            {{
              (
                sum(
                  betList.filter((item) => item.orderStatus != 2),
                  "peie"
                ) +
                sum(
                  betList.filter((item) => item.orderStatus != 2),
                  "back"
                ) -
                sum(
                  betList.filter((item) => item.orderStatus != 2),
                  "money"
                ) *
                  1
              ).toFixed(2)
            }}
          </td>
          <td colspan="2"></td>
        </tr>
      </tbody>
    </table>
    <Paging
      class="center"
      :current_page="current_page"
      :last_page="last_page"
      @pre="pre()"
      @next="next()"
      @goFirst="firstPage()"
      @goLast="lastPage()"
    />
  </div>
</template>

<script>
import DropDownMenu from "@/components/DropDownMenu";
import Paging from "@/components/Paging";
export default {
  data() {
    return {
      isComeFromPeriod: false,
      choiceOption: "hn5fc",
      gameList: [],
      beforDate: this.$getBeforeDate(0, "yyyy-MM-dd"),
      issue: "",
      orderId: "",
      nowIssue: "",
      isClose: 0,
      status: -1,
      issueList: [],
      checkAll: false,
      current_page: 1,
      last_page: 1,
      limit: 15,
      statusList: [
        { value: -1, label: "全部" },
        { value: 0, label: "成功" },
        { value: 6, label: "未中" },
        { value: 5, label: "中奖" },
        { value: 2, label: "退码" },
        { value: 4, label: "撤回" },
      ],
      betList: [],
    };
  },
  components: {
    DropDownMenu,
    Paging,
  },
  props: ["initFinished", "goIssue"],
  watch: {
    initFinished() {
      this.initData();
    },
    beforDate(newVal) {
      if (this.isComeFromPeriod) {
        this.getIssueList(this.goIssue);
      } else {
        this.getIssueList();
      }
    },
    issue() {
      this.search();
    },
    current_page() {
      this.search();
    },
    checkAll(newVal) {
      this.betList.forEach((item) => {
        item.checked = newVal;
      });
    },
  },
  mounted() {
    this.initData();
  },
  computed: {
    beforDateList() {
      let arr = [];
      for (let i = 0; i < 7; i++) {
        let date = this.$getBeforeDate(i, "yyyy-MM-dd");
        arr.push({
          label: date,
          value: date,
        });
      }
      return arr;
    },
  },
  methods: {
    async initData() {
      if (this.initFinished) {
        this.computedGameList();
        if (this.goIssue) {
          this.isComeFromPeriod = true;
          this.beforDate = `${this.goIssue.substr(0, 4)}-${this.goIssue.substr(
            4,
            2
          )}-${this.goIssue.substr(6, 2)}`;
          await this.getIssueList(this.goIssue);
          this.$emit("clean-goIssue");
        } else {
          await this.getIssueList();
        }
      }
    },
    computedGameList() {
      this.$store.state.gameInfo.forEach((element) => {
        this.gameList.push({
          label: element.gameName,
          value: element.code,
        });
      });
    },
    async getIssueList(issue) {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        game_code: this.$store.state.gameInfo[0].code,
        date: this.beforDate.replace(/-/g, ""),
      };
      let result = await this.$http.postAxiosMethod("/user/issuelist", data);
      if (result.code == 0) {
        let arr = [];
        result.data.forEach((item) => {
          arr.push({
            label: item,
            value: item,
          });
        });
        this.issueList = arr;
        if (issue && issue !== "") {
          this.issue = issue;
          this.isComeFromPeriod = false;
        } else {
          this.issue = this.issueList[0].value;
        }
      }
    },
    async search() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        code: this.$store.state.gameInfo[0].code,
        qihao: this.issue,
        beforDate: this.beforDate.replace(/-/g, ""),
        orderStatus: this.status == -1 ? "" : this.status,
        orderId: this.orderId,
        page: this.current_page,
        limit: this.limit,
      };
      let result = await this.$http.postAxiosMethod("/user/betlist", data);
      if (result.code == 0) {
        this.nowIssue = this.$store.state.gameInfo[0].nextQihao;
        this.isClose = this.$store.state.gameInfo[0].isClose;
        let betList = JSON.parse(JSON.stringify(result.data));
        betList.forEach((item) => {
          item.checked = false;
        });
        this.betList = betList;
        this.last_page = Math.ceil(result.count / this.limit) || 1;
      }
    },
    async recharge() {
      let orderSubIdsArr = [];
      this.betList.forEach((item) => {
        if (item.checked && item.orderStatus != 2) {
          orderSubIdsArr.push(item.orderSubId);
        }
      });
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        orderSubIds: orderSubIdsArr.join(","),
        code: this.$store.state.gameInfo[0].code,
        qihao: this.issue,
      };
      let result = await this.$http.postAxiosMethod("/user/chargeback", data);
      if (result.code == 0) {
        this.$message({
          message: "退码成功",
          type: "success",
        });
        this.checkAll = false;
        this.search();
        setTimeout(() => {
          this.$BUS.$emit("bet");
        }, 500);
      }
    },
    async batchCharge() {
      if (this.orderId.trim() === "") {
        document.activeElement.blur();
        this.$alert("请输入注单编号", "提示");
        return;
      }
      this.$confirm(`${this.orderId} 订单号，确定退码吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {
            access_token: this.$store.state.userInfo.access_token,
            uid: this.$store.state.userInfo.uid,
            orderId: this.orderId,
            code: this.$store.state.gameInfo[0].code,
            qihao: this.issue,
          };
          let result = await this.$http.postAxiosMethod(
            "/user/chargebackForOrderid",
            data
          );
          if (result.code == 0) {
            this.$message({
              message: "退码成功",
              type: "success",
            });
            this.search();
            setTimeout(() => {
              this.$BUS.$emit("bet");
            }, 500);
          }
        })
        .catch(() => {});
    },
    firstPage() {
      this.current_page = 1;
    },
    pre() {
      if (this.current_page > 1) {
        this.current_page--;
      }
    },
    next() {
      if (this.current_page < this.last_page) {
        this.current_page++;
      }
    },
    lastPage() {
      this.current_page = this.last_page;
    },
    sum(list, key) {
      let sum = 0;
      list.forEach((item) => {
        if (key == "num") {
        }
        if (item.winorlose || item.peie) {
          sum += item[key] * 1;
        } else {
          sum += 0;
        }
      });
      return sum || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.bet-detail-page {
  background: var(--new-bg-white);
  input[type="text"] {
    border: 1px solid var(--new-border);
    opacity: 0.7;
  }
  .charge {
    background-color: rgb(255, 193, 132) !important;
  }
  .nav {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 14px 0 0;
    height: 40px;
    font-size: 13px;
    background: var(--new-bg-white);
    & > span {
      margin: 0 15px;
    }
    .search-order {
      width: 100px;
      height: 22px;
      background: var(--new-bg-white);
      padding: 5px;
      font-size: 13px;
    }
    .search {
      margin-left: 15px;
      //   width: 60px;
      //   height: 22px;
      //   background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
      //   border-radius: 2px;
      //   color: #fff;
      //   font-size: 13px;
      //   cursor: pointer;
    }
    .recharge {
      width: unset;
      margin-left: 15px;
      background: transparent;
      //   width: 84px;
      //   height: 22px;
      //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
      //   border-radius: 2px;
      //   color: #fff;
      //   font-size: 13px;
      //   cursor: pointer;
    }
  }
  .detail-table {
    // margin-bottom: 15px;
    width: 100%;
    font-size: 12px;
    background: var(--new-bg-white);
    th {
      padding: 0 20px;
      font-weight: bold;
      color: var(--new-text-info);
      background: var(--new-bg-table-header-main);
      line-height: 30px;
      height: 30px;
      text-align: left;
      border-bottom: 1px solid var(--new-border);
    }
    td {
      line-height: 30px;
      height: 30px;
      text-align: left;
      padding: 0 20px;
      border-bottom: 1px solid var(--new-border);
    }
    tr.summary {
      td {
        background: var(--new-bg-table-summary);
      }
    }
    // tr {
    //   &:nth-child(n) {
    //     background: #f0f0f0;
    //   }
    //   &:nth-child(2n) {
    //     background: #fff;
    //   }
    // }
  }
}
.paging {
  ::v-deep {
  }
}
</style>
